<div class="min-h-screen w-full flex flex-col">
    <div class="flex justify-center">
        <div class="flex flex-col gap-2 w-[384px] sm:w-[620px] md:w-[748px] lg:w-[1000px]">
            <div class="flex flex-row items-center justify-start text-slate-800">
                <div class="grow text-xl font-title font-bold">Blog and Updates</div> 
                @if (singlePost) {
                    <a href="/news" class="hover:text-ponder-linkhover text-sm">Back to all posts →</a>
                }
            </div>
            <loading [isLoading]="isLoading" [success]="true"></loading>
            @if (!isLoading && loadingSuccess) {
                @if (posts.length > 0) {
                    @for (post of posts ; track post.id) {
                        <div class="flex flex-row">
                            <news-post [title]="post.title!" [content]="post.content!" [authorUsername]="post.author.username!" [authorDisplayName]="post.author.displayName" [createdAt]="post.createdAt" [modifiedAt]="post.modifiedAt" [id]="post.id" [truncated]="post.truncated" class="grow text-sm"></news-post>
                        </div>
                    }
                }
            } @else {
                <div class="flex flex-row p-4 items-center justify-center bg-slate-100 rounded shadow-sm text-slate-400">
                    Post Not Found
                </div>
            }
        </div>
    </div>
</div>